import { render, staticRenderFns } from "./scanVsReportBarChart.vue?vue&type=template&id=25a99284&scoped=true"
import script from "./scanVsReportBarChart.vue?vue&type=script&lang=js"
export * from "./scanVsReportBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a99284",
  null
  
)

export default component.exports